import React, { useEffect, useRef } from "react";
import "../styles/home.scss";
import EcosystemSection from "../components/IntelligentEcosystem";
import ProvenIntelligence from "../components/ProvenIntelligence";
import { useNavigate } from "react-router-dom";

const SOLUTION_CARDS = [
  {
    id: 1,
    title: "Intelligent Power Procurement Strategy",
    description: "Always Buy Power at the Right Cost",
    image: "/image/solution-frame1.jpg"
  },
  {
    id: 2,
    title: "Flexibility & Storage Optimisation",
    description: "Unlock New Value from Flexibility and Storage",
    image: "/image/solution-frame2.jpg"
  },
  {
    id: 3,
    title: "Automated Power Market Participation",
    description: "Let the System Participate in Power Markets for You",
    image: "/image/solution-frame3.jpg"
  },
  {
    id: 4,
    title: "Adaptive Demand & Load Intelligence",
    description: "Reduce Your Energy Costs by Optimizing How You Consume",
    image: "/image/solution-frame4.jpg"
  },
  {
    id: 5,
    title: "Unified Meter-to-Market Intelligence Layer",
    description: "Turn Your Energy Data into Strategic Intelligence",
    image: "/image/solution-frame5.jpg"
  }
];

const INVESTMENT_CARDS = [
  {
    id: 1,
    number: "01",
    title: "Rising Energy Costs",
    description: "Frequent price fluctuations make energy budgeting unpredictable and increase operational risk.",
    icon: "/image/icon1.svg"
  },
  {
    id: 2,
    number: "02",
    title: "Overpurchase and Energy Lapse Risk",
    description: "Without real-time consumption visibility, businesses risk over-procuring power, leading to financial losses from unused energy and potential deviation penalties.",
    icon: "/image/icon2.svg"
  },
  {
    id: 3,
    number: "03",
    title: "Fragmented Energy Data",
    description: "Consumption data is scattered across systems, making it difficult to gain a unified cost and usage view.",
    icon: "/image/icon3.svg"
  },
  {
    id: 4,
    number: "04",
    title: "Inefficient Power Procurement",
    description: "Limited sourcing strategies prevent businesses from securing the most cost-effective energy mix.",
    icon: "/image/icon4.svg"
  },
  {
    id: 5,
    number: "05",
    title: "No Real-Time Consumption Intelligence",
    description: "Without live monitoring, businesses cannot align procurement decisions with actual load behaviour, leading to avoidable inefficiencies.",
    icon: "/image/icon1.svg"
  },
  {
    id: 6,
    number: "06",
    title: "Growing Compliance & Sustainability Pressure",
    description: "Stricter regulations and ESG mandates demand greater energy transparency and accountability.",
    icon: "/image/icon1.svg"
  }
];

// const lines = document.querySelectorAll(".invert-line");

// window.addEventListener("scroll", () => {
//   const triggerStart = window.innerHeight * 0.8;

//   lines.forEach((line) => {
//     const rect = line.getBoundingClientRect();

//     const progress = 1 - Math.min(Math.max(rect.top / triggerStart, 0), 1);

//     const position = 100 - progress * 100;

//     line.style.backgroundPositionX = `${position}%`;
//   });
// });


function Homepage() {
  const navigate = useNavigate();
  const wrapperRef = useRef(null);

  // useEffect(() => {
  //   // Create overlay to cover body with cursor-based radial gradient
  //   const overlay = document.createElement('div');
  //   overlay.className = 'flashlight-overlay';
  //   document.body.appendChild(overlay);

  //   const handleMouseMove = (e) => {
  //     const x = e.clientX;
  //     const y = e.clientY;

  //     // Update overlay mask to reveal background at cursor
  //     overlay.style.setProperty('--cursor-x', x + 'px');
  //     overlay.style.setProperty('--cursor-y', y + 'px');
  //   };

  //   window.addEventListener('mousemove', handleMouseMove);

  //   return () => {
  //     window.removeEventListener('mousemove', handleMouseMove);
  //     if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
  //   };
  // }, []);

  const handleMouseMove = (e) => {
    if (wrapperRef.current) {
      wrapperRef.current.style.setProperty('--cursor-x', `${e.clientX}px`);
      wrapperRef.current.style.setProperty('--cursor-y', `${e.clientY}px`);
    }
  }


  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <video autoPlay muted loop className="hero-video">
          <source src="/image/header-video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="hero-content">
            <h1>Powering the Future of Intelligent Energy Ecosystem</h1>
            <p>
              End-to-end smart metering solutions for a smarter, data-driven energy ecosystem.
            </p>
          </div>
        </div>
      </section>

      {/* ========================================= */}
      {/* FLASHLIGHT WRAPPER START */}
      {/* ========================================= */}
      <div
        className="flashlight-wrapper"
        ref={wrapperRef}
        onMouseMove={handleMouseMove}
      >
        {/* The overlay is now injected here */}
        <div className="flashlight-overlay"></div>

        {/* Gold Coin Section */}
        <section className="gold-coin">
          <div className="container">

            <div className="gold-heading">
              <span className="highlight">Every Unit of Energy</span>is a <span className="gold-text">Gold Coin.</span>
            </div>
            <div className="row g-0">
              <div className="col-lg-6">
                <p>
                  Most businesses see energy only as a bill. We help you see patterns, predict outcomes, and take control in real time.
                </p>
                <button className="btn btn-green"
                  onClick={() => navigate("/LeadForm")}
                >Start 45-Day Free Trial
                  <img src="/image/arrow-right.svg" alt="arrow" />
                </button>
              </div>
              <div className="col-lg-6">
                <div className="gold-visual">
                  <img src="/image/Energy-Distribution-Isometric-1.gif" alt="Gold Coin Visualization" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Unified Energy Section */}
        <EcosystemSection />
        {/* Solutions Section */}
        <section className="solutions">
          <div className="container solutions-wrapper">
            <div className="solutions-sidebar">
              <h2>Our <span className="highlight">Solutions</span></h2>
              <p>Built for Every Energy Stakeholder</p>
              {/* <button className="btn btn-green">Learn More</button> */}
            </div>

            <div className="solutions-content">
              <div className="solutions-grid">
                {SOLUTION_CARDS.map((card, index) => (
                  <div
                    key={card.id}
                    className={`solution-card`}
                    style={{ backgroundImage: `url(${card.image})` }}
                  >
                    <h3>{card.title}</h3>
                    <p>{card.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* ========================================= */}
      {/* FLASHLIGHT WRAPPER END */}
      {/* ========================================= */}

      {/* Investment Section */}
      <section className="investment">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="investment-sidebar">
                <h2>Why Bother Investing in <span className="highlight-white">Energy Optimisation?</span></h2>
                <p>
                  Well, the short answer is- energy is one of the largest controllable expenses in business, often accounting for 10–12% of operational costs.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              {INVESTMENT_CARDS.map((card) => (
                <div key={card.id} className="Optimisation">
                  <img src={card.icon} alt="" className="Optimisation-icon-img" width={68} />
                  <hr />
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                  <div className="Optimisation-icon">{card.number}</div>
                </div>
              ))}
            </div>
          </div>



        </div>
      </section>

      {/* Impact Section */}
      <section className="impact">
        <div className="container">
          <h2>
            Proven Intelligence. <span className="highlight">Measurable Impact.</span>
          </h2>
          <p>A sneak-peek into how intelligent analytics and automation helped industrial consumers turn operational pressure into measurable advantage with real savings, real stability, and real impact.</p>
        </div>
      </section>

      <ProvenIntelligence />

      {/* <h2 className="animated-title">
        <span className="invert-line">From vision to reality, we create designs</span>
        <span className="invert-line">that tell your brand's story and engage</span>
        <span className="invert-line">your audience in an authentic way.</span>
      </h2> */}
    </>
  );
}

export default Homepage;